import { render } from "./TalentTest.vue?vue&type=template&id=674d38b3&scoped=true"
import script from "./TalentTest.vue?vue&type=script&lang=js"
export * from "./TalentTest.vue?vue&type=script&lang=js"

import "./TalentTest.vue?vue&type=style&index=0&id=674d38b3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-674d38b3"]])

export default __exports__